import { DateTime } from 'luxon'

export default (date, format = 'dd/MM/yyyy') => DateTime.fromISO(date).toFormat(
  format,
)
